import React, { Suspense } from 'react';
import { Loader } from 'semantic-ui-react';

const WaitingComponent = Component => props => (
  <Suspense fallback={<div style={{flexGrow:1,justifyContent:"center",alignItems:"center",display:"flex"}}><Loader active size="huge" content="Yükleniyor"/></div>}>
    <Component {...props} />
  </Suspense>
);

export default WaitingComponent;